import React, { FC } from 'react';
import { MicroFrontend, SpecificMicroFrontendProps } from '../../core';
import { constants } from './constants';

export type ScrapMicroFrontendProps = SpecificMicroFrontendProps;

export const ScrapMicroFrontend: FC<ScrapMicroFrontendProps> = ({ entryPointUrl, ...props }) => {
  return (
    <MicroFrontend
      entryPointUrl={entryPointUrl}
      name={constants.MFE_SCRAP_NAME}
      exposedPath={constants.MFE_EXPOSED_PATH}
      {...props}
    />
  );
};
